<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
       <el-input placeholder="구글OTP" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
    <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
		<el-button type="success" size="mini" @click="editContent(false)">{{$t('tableText.추가')}}</el-button> 
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
        <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
         <el-table-column 
         label="ID" prop="id" align="center" width="150">
         </el-table-column>

         <el-table-column 
         :label="$t('tableText.알본사')" v-if="this.sitetype==4" prop="admin_id" align="center" width="150">
         </el-table-column>

         <el-table-column 
         :label="$t('searchText.키워드')" prop="title2" align="center" width="200">
         </el-table-column> 

         <el-table-column 
         :label="$t('msg.제목')" prop="title" align="center" width="200">
         </el-table-column> 
          <el-table-column 
         :label="$t('msg.내용')" prop="contents" align="center">
          <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="4"
            v-model="scope.row.contents">
          </el-input>
          </template>
         </el-table-column>  
         <el-table-column 
         :label="$t('tableText.시간')" prop="add_time" align="center" width="200">
         </el-table-column> 
           <el-table-column :label="$t('status.편집')" align="center"  width="200">
             <template slot-scope="scope">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editContent(scope)"></el-button>
              </template>
          </el-table-column> 
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>
         <el-dialog
         :title="this.editIndex===-1 ? $t('tableText.추가') :$t('status.편집')"
          :visible.sync="creatModel" :close-on-click-modal ="false" :width="aWidth">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('searchText.키워드')"  prop="title2" class="mb-1">
              <el-input v-model="form.title2" :placeholder="$t('searchText.리스트에노출될키워드')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.제목')" prop="title" class="mb-1">
              <el-input v-model="form.title" :placeholder="$t('msg.답변제목')"></el-input>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')"  prop="contents" class="mb-1">
            <!--    <el-input
                type="textarea"
                :rows="12"
                v-model="form.contents" :placeholder="$t('msg.답변내용')">
              </el-input> -->
               <quill-editor 
                                v-model="form.contents" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>	

      
				
</div>
 </template>

 <script>
  import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

      
    export default {
     components: {
    quillEditor
    },
    	data(){
    		return{
            editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
          aWidth:'600px',
          otp:'',
             domain:window.sessionStorage.getItem('domain'),
             sitetype:window.sessionStorage.getItem('sitetype'),
    	       form:{
              title2:'',
              title:'',
              contents:'',
              id:'',
             },
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			       currentPage:1,
			       multipleSelection:[],
             rules: {
                  title:[{ required: true, message: '', trigger: 'blur'}],
                  title2:[{ required: true, message: '', trigger: 'blur'}],
                  contents:[{ required: true, message: '', trigger: 'blur'}],
                },
              

    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
    }
  },
    	methods:{
         change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               this.form.admin_contents = event.html
          }, 
        editContent(e = false){
          let token=window.sessionStorage.getItem('user');
          //tianjia
          if(!e){
            this.form = {
                content:'',
                title:'',
                title2:''
                 }
             this.editIndex = -1

          }
          else{
             //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqa_id?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data
                 // console.log('data==',item)
                  
                    this.form = {
                          title:item.title,
                          contents:item.contents,
                          id:item.id,
                          title2:item.title2

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })


          }
        
          this.creatModel = true
         
        },
    			 
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    			
    			 let urls=this.domain+'/admin/autoqalist?page='+this.currentPage;
    			 this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },    
            }).then((response) =>{ 


                    // console.log('tableData=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
              
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		changeVisit(e){
              let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/board_up',
                      data:{  
                            visit:e.row.visit,
                            id:e.row.sid
                      },
                            
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                   if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                    }
                    else{
                      this.$message({
                        message:'완료',
                        type:'success'
                    })    
                    }         
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
        },
    		  submit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/autoqa_add',
                        data:{
                          contents:this.form.contents,
                          id:this.form.id,
                          title:this.form.title,
                          title2:this.form.title2
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:'완료',
                                type:'success'
                               });
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                            this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/autoqa_up',
                      data:{
                          id:this.form.id,
                          contents:this.form.contents,
                          title:this.form.title,
                          title2:this.form.title2
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                           message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
    	handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
        // 批量删除
      deleteAll(){
         this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"),this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.id);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                   data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/autoqa_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		
    	}
  }
</script>

 <style scoped>
/deep/ .el-dialog__body{
  padding: 5px 10px;
}
/deep/.el-dialog__footer{
  padding: 0px 20px 20px;
}
>>>.ql-container.ql-snow{
  height:150px!important
}
</style>


// WEBPACK FOOTER //
// src/views/autoqa/list.vue